package com.rosario.juridico.platform

actual val API_BASE_URL: String get() = kotlinx.browser.window.location.origin
